import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { CountryISO } from 'ngx-intl-tel-input';
import { Router } from '@angular/router';

declare var $;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public feedbackInfoForm:boolean=true;
  public feedbackOtpForm:boolean=false;
  public feedbackThankForm:boolean=false;
  CountryISO = CountryISO;
  cityList:any=[];

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private fb: FormBuilder, private service: AppService,private router:Router) { 

    this.service.post("/getCityNameByState",{state_id:33}).subscribe((data:any)=>{
      if(data[0].error == 0){
        this.cityList = data[0].result;
      }
    })

  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // $(".call-connect").click(function () {
      //   $(".call-menu").toggleClass("active");
      // });

      $(window).scroll(function () {
        if ($(window).scrollTop() >= 800) {
          $('.static-ad').addClass('show-static-ad');
        }
        else {
          $('.static-ad').removeClass('show-static-ad');
        }
        $(".call-menu").removeClass("active");
      });

      $('.feedback-first input:radio').change(function () {
        if ($(this).is(":checked")) {
          $('.feedback-form').addClass("feedback-second-show");
        }
      });
    }

    this.callback.get("contact_no").valueChanges.subscribe((val)=>{
      if(val){
        this.callback.patchValue({
          phone_code:val.dialCode,
          phone:val.number

        })        
      }
    })
  }

  openFeedbackForm(){
    $(".feedback-form").toggleClass("feedback-show");
    $('.feedback-form').removeClass("feedback-second-show");
    $('input[name="feedback"]').prop('checked', false);
    this.feedbackSubmit=false;
    this.feedbackErrorMsg="";
    this.feedbackSuccessMsg="";
    this.feedback.reset();
    this.feedbackverify.reset();
  }

  callback = this.fb.group({
    name:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$')]],
    phone:[''],
    message: [''],
    phone_code: ['91'],
    contact_no:['',[Validators.required]]
  });

  get callbackControl() { return this.callback.controls; }

  callbackSubmit: boolean = false;
  callbackLoader: boolean = false;
  callbackErrorMsg: string = "";
  callbackSuccessMsg: string = "";
  callbackEnd() {
    this.callbackErrorMsg = "";
    this.callbackSuccessMsg = "";
    this.callbackSubmit = true;
    if (this.callback.valid) {
      this.callbackLoader = true;
      this.callback.patchValue({
        phone : this.callback.value.phone.replace(/\s+/g, '')
      })
      console.log(this.callback.value);
      this.service.post('/callbackEnd', this.callback.value).subscribe(
        (data: any) => {
          console.log(data);
          if (data[0].error == '0') {
            this.callbackSuccessMsg = data[0].msg;
            this.callback.reset();
            this.callbackSubmit = false;
          } else {
            this.callbackErrorMsg = data[0].msg;
          }

          this.callbackLoader = false;
        }, (error: any) => {
          this.callbackErrorMsg = error.errorDesc;
          this.callbackLoader = false;
        }
      )
    }
  }

  contact = this.fb.group({
    name: ['', Validators.required],
    phone: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
    message: [''],
  })

  get contactControl() { return this.contact.controls; }

  contactSubmit: boolean = false;
  contactLoader: boolean = false;
  contactErrorMsg: string = "";
  contactSuccessMsg: string = "";
  contactEnd() {
    this.contactErrorMsg = "";
    this.contactSuccessMsg = "";
    this.contactSubmit = true;

    if (this.contact.valid) {
      this.contactLoader = true;
      this.service.post('/contactEnd', this.contact.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            this.contactSuccessMsg = data[0].msg;
            this.contact.reset();
            this.contact.patchValue({ "state_id": '', "city_id": '' });
            this.contactSubmit = false;
          } else {
            this.contactErrorMsg = data[0].msg;
          }

          this.contactLoader = false;
        }, (error: any) => {
          this.contactErrorMsg = error.errorDesc;
          this.contactLoader = false;
        }
      )
    }
  }


  newsletter = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  })

  get newsletterControl() { return this.newsletter.controls; }

  newsletterSubmit: boolean = false;
  newsletterLoader: boolean = false;
  newsletterErrorMsg: string = "";
  newsletterSuccessMsg: string = "";
  newsletterEnd() {
    this.newsletterErrorMsg = "";
    this.newsletterSuccessMsg = "";
    this.newsletterSubmit = true;

    if (this.newsletter.valid) {
      this.newsletterLoader = true;
      this.service.post('/subscribeNewsletter', this.newsletter.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            this.newsletterSuccessMsg = data[0].msg;
            this.newsletter.reset();
            this.newsletterSubmit = false;
          } else {
            this.newsletterErrorMsg = data[0].msg;
          }

          this.newsletterLoader = false;
        }, (error: any) => {
          this.newsletterErrorMsg = error.errorDesc;
          this.newsletterLoader = false;
        }
      )
    }
  }

  feedback = this.fb.group({
    rating: ['', Validators.required],
    message: ['', Validators.required],
    mobile:['',[Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
    email: ['', [Validators.required, Validators.email]]
  });

  get feedbackControl() { return this.feedback.controls; }

  feedbackSubmit: boolean = false;
  feedbackLoader: boolean = false;
  feedbackErrorMsg: string = "";
  feedbackSuccessMsg: string = "";
  feedbackEnd() { 
    this.feedbackErrorMsg = "";
    this.feedbackSuccessMsg = "";
    this.feedbackSubmit = true;
    if (this.feedback.valid) {
      this.feedbackLoader = true;
      this.service.post('/feedbackEnd', this.feedback.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') { 
            this.feedbackInfoForm=false;
            this.feedbackOtpForm=true;
          } else {
            this.feedbackErrorMsg = data[0].msg;
          } 
          this.feedbackLoader = false;
        }, (error: any) => {
          this.feedbackErrorMsg = error.errorDesc;
          this.feedbackLoader = false;
        }
      )
    }
  }

  feedbackverify = this.fb.group({
    otp: ['', Validators.required]
  });

  get feedbackVerifyControl() { return this.feedbackverify.controls; }

  chkFeedbackVerify(){
    this.feedbackErrorMsg = "";
    this.feedbackSuccessMsg = "";
    if(this.feedbackverify.valid){
      this.feedbackLoader=true;
      this.service.post('/verifyFeedback',{"otp":this.feedbackverify.value.otp,"mobile":this.feedback.value.mobile}).subscribe(
        data=>{
          if(data[0].error){
            this.feedbackErrorMsg=data[0].msg;
          }else{
            this.feedback.reset();
            this.feedbackverify.reset();
            this.feedbackOtpForm=false;
            this.feedbackThankForm=true;
          }

          this.feedbackLoader=false;
        },
        error=>{
          this.feedbackErrorMsg=error.errorDesc;
          this.feedbackLoader=false;
        }
      )
    }
  }

  numberOnly(event, length = 0, pointAllow = 0) {
    const iKeyCode = (event.which) ? event.which : event.keyCode;
    if ((pointAllow == 1 && (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))) || (pointAllow == 0 && (iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)))) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }


  redirectToAnotherPage(url:any,city:any){
    var find_City = this.cityList.find((x:any) => x.slug === city);
    var data=JSON.parse(localStorage.getItem('selSearchCity'));
    data.id=find_City.id;
    data.name=find_City.name;
    data.slug=find_City.slug; 
    localStorage.setItem('selSearchCity', JSON.stringify(data));
    this.router.navigateByUrl(url+city);
  }

}
